import { apiGet, apiPost } from '../utils/api'

export const getReportingConfigAPI = (groupName) => {
  return apiGet(`mgmt/shopSettings/group/${groupName}`)
}

export const updateReportingConfigAPI = (data, groupName) => {
  return apiPost(`mgmt/shopSettings/update/${groupName}`, data)
}



// WEBPACK FOOTER //
// ./src/api/reporting.js